<template>
    <div class="vc-navigation">
        <div
            v-for="tab of tabs"
            :key="tab.menuId"
            :id="`vc-navigation-tab-${tab.menuId}`"
            :class="{
                'vc-navigation-tab': true,
                'vc-navigation-tab-active': activeTabId === tab.menuId,
            }"
            tabindex="0"
            @mouseenter="openTab(tab.menuId)"
            @mouseleave="closeTabAfterTimeout"
            @keyup.enter="toggleTab(tab.menuId)"
        >
            <span v-html="tab.text" />
            <NavigationItems
                v-show="activeTabId === tab.menuId"
                :show-redesign-opt-in="!!tab.showRedesignOptIn"
                :tab="tab"
            />
        </div>
    </div>
</template>
<script>
import { mapState } from 'pinia';
import { Weblabs } from '../enums/Weblabs';
import { useNavigationStore } from '../stores/navigationStore';
import { useContextStore } from '../stores/contextStore';
import { useVendorStatusStore } from '../stores/vendorStatusStore';
import getWeblabTreatment from '../util/getWeblabTreatment';
import NavigationItems from './NavigationItems';

export default {
    name: 'TheNavigation',
    components: { NavigationItems },
    data() {
        return {
            activeTabId: null,
            closeTimeout: null,
        };
    },
    computed: {
        ...mapState(useNavigationStore, ['navigation']),
        ...mapState(useContextStore, ['customerId', 'vendorGroup', 'marketscope']),
        ...mapState(useVendorStatusStore, ['vendorStatus']),
        hideNavigation() {
            return (
                this.vendorStatus === 'submitted' || // Vendor group in setup/registration
                (this.customerId && !this.vendorGroup) // Logged in but not authorized to a vendor group yet (e.g. account selection page)
            );
        },
        tabs() {
            if (!this.navigation || !this.navigation.subNav || this.hideNavigation) {
                return [];
            }
            const tabs = this.navigation.subNav.filter((tab) => tab.subNav && tab.subNav.length > 0);
            if (getWeblabTreatment(Weblabs.navRedesign) === 'T1') {
                const settingsTab = tabs.find((tab) => tab.menuId === 'settings');
                if (settingsTab) {
                    settingsTab.showRedesignOptIn = true;
                } else {
                    tabs.push({
                        menuId: 'settings',
                        text: this.$t('header_utilityBar_alt_settings'),
                        showRedesignOptIn: true,
                        subNav: [],
                    });
                }
            }
            return tabs;
        },
    },
    created() {
        useContextStore().loadContext();
        useNavigationStore().loadNavigation();
        useVendorStatusStore().loadVendorStatus();
    },
    methods: {
        openTab(tabId) {
            clearTimeout(this.closeTimeout);
            this.activeTabId = tabId;
        },
        closeTabAfterTimeout() {
            if (!this.activeTabId) {
                return;
            }
            this.closeTimeout = setTimeout(() => {
                this.activeTabId = null;
            }, 100);
        },
        toggleTab(tabId) {
            if (this.activeTabId === tabId) {
                this.activeTabId = null;
            } else {
                this.openTab(tabId);
            }
        },
    },
};
</script>
<style lang="scss">
.vc-navigation {
    background: linear-gradient(#222 0%, #434343 40%, #383838 90%, #333 100%);
    color: white;
    display: flex;
    font-size: 13px;
    height: 30px;
    line-height: 16px;

    &-tab {
        margin: 2px 1px 0;
        padding: 5px 13px 7px;
        position: relative;
        white-space: nowrap;

        sup {
            font-size: 75%;
            line-height: 0;
            position: relative;
            top: -0.5em;
            vertical-align: baseline;
        }

        &-active {
            background: white;
            color: black;
        }
    }
}
</style>
